import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getFuelTypeList,
	addNewFuelType,
	updateFuelType,
	deleteFuelType,
	getFuelType,
} from '../fuelType/thunk';

export const initialState = {
	itemFuelTypeList: [],
	itemFuelTypeDetail: null,
	isFuelTypeLoading: false,
	isFuelTypeSuccess: false,


	fuelTypeList: [],
	fuelTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const FuelTypeSlice = createSlice({
	name: 'FuelType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getFuelType.fulfilled, (state, action) => {
			state.isFuelTypeLoading = false;
			state.isFuelTypeSuccess = true;
			state.itemFuelTypeDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getFuelType.pending, state => {
			state.isFuelTypeLoading = true;
			state.isFuelTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getFuelType.rejected, (state, action) => {
			state.isFuelTypeLoading = false;
			state.isFuelTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getFuelTypeList.pending, state => {
			state.isFuelTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getFuelTypeList.fulfilled, (state, action) => {
			state.itemFuelTypeList = action.payload;
			state.fuelTypeList = action.payload;
			state.isLoadingList = false;
			state.isFuelTypeSuccess = true;

			let fuelTypeListSelect = [];
			action.payload.map(item =>
				fuelTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.fuelTypeListSelect = fuelTypeListSelect;
		});
		builder.addCase(getFuelTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isFuelTypeSuccess = true;
		});
		builder.addCase(addNewFuelType.fulfilled, (state, action) => {
			state.itemFuelTypeList.push(action.payload);
			state.fuelTypeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewFuelType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewFuelType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateFuelType.fulfilled, (state, action) => {
			state.itemFuelTypeList = state.itemFuelTypeList.map(fuelType =>
				fuelType.fuelTypename === action.payload.old_fuelType
					? { ...fuelType, ...action.payload.updated_fuelType }
					: fuelType
			);
			state.fuelTypeList = state.fuelTypeList.map(fuelType =>
				fuelType._id.toString() === action.payload._id.toString()
					? { ...fuelType, ...action.payload }
					: fuelType
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateFuelType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateFuelType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteFuelType.fulfilled, (state, action) => {
			state.itemFuelTypeList = current(state.itemFuelTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.fuelTypeList = current(state.fuelTypeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteFuelType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteFuelType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = FuelTypeSlice.actions;

export default FuelTypeSlice.reducer;
